// src/components/Navigation.js
import React from "react";

const Navigation = ({ activeSection, setActiveSection, scrolled }) => {
	const sections = [
		"about",
		"bolt",
		"experience",
		"projects",
		"businesscard",
		"skills",
	];
	const sectionNames = [
		"About",
		"BOLT",
		"Experience",
		"Personal Projects",
		"Business Card",
		"Skills",
	];

	const handleSectionChange = (section) => {
		setActiveSection(section);

		// Update URL hash without page reload
		window.history.pushState(null, null, `#${section}`);

		// Scroll the (always-present) content container up under the nav.
		const element = document.getElementById("main-content");
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	return (
		<nav
			className={`sticky top-0 z-20 transition-all duration-300 ${
				scrolled
					? "bg-white/80 backdrop-blur-md border-b border-slate-200/80 shadow-soft py-2.5"
					: "bg-transparent py-4"
			}`}
		>
			<div className="container mx-auto px-6">
				<div className="flex justify-center md:justify-start gap-1 md:gap-1.5 overflow-x-auto">
					{sections.map((section) => (
						<button
							key={section}
							onClick={() => handleSectionChange(section)}
							className={`py-2 px-4 text-sm font-medium rounded-full whitespace-nowrap transition-all duration-300 ${
								activeSection === section
									? "bg-brand-600 text-white shadow-xs shadow-brand-600/30"
									: "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
							}`}
						>
							{sectionNames[sections.indexOf(section)]}
						</button>
					))}
				</div>
			</div>
		</nav>
	);
};

export default Navigation;
